<div class="company-access mb-footer">
    <div class="container">
        <div class="row">
            <!-- section title -->
            <div class="col-md-12 my-md-5 mb-5 sec-title">
                <app-title-page [dataTitle]="dataTitle" [link]="'#corporate'">
                    <div class="con-address" *ngIf="dataAddress">
                        <div class="comad-detail my-4" [innerHTML]="dataAddress.description"></div>
                        <div class="address px-3">
                            <div class="location pb-3 d-flex">
                                <div class="pr-4"><i class="icon ion-md-pin"></i></div>
                                <div [innerHTML]="dataAddress.location"></div>
                            </div>
                            <div class="telephone pb-3 d-flex">
                                <div class="pr-4"><i class="icon ion-md-call"></i></div>
                                <p>{{ dataAddress.telp }}</p>
                            </div>
                            <div class="print d-flex">
                                <div class="pr-4"><i class="icon ion-md-print"></i></div>
                                <p>{{ dataAddress.fax }}</p>
                            </div>
                        </div>
                    </div>
                </app-title-page>
            </div>
            <!-- contents -->
            <div class="col-md-12 sec-contents" id="corporate">
                <div class="lane-top">
                    <div class="row mt-5" *ngIf="dataCorporate">
                        <div class="col-md-6 profile" *ngFor="let corporate of dataCorporate">
                            <div class="border-type-1 position-relative h-100 no-list p-3">
                                <h6 class="px-3 posi">{{ corporate.position }}</h6>
                                <h5 class="f-titb">{{ corporate.fullname }}</h5>
                                <div class="bio text-justify no-list mt-4 pb-5" [innerHTML]="corporate.description"></div>
                                <a href="mailto:{{corporate.email}}" class="email d-flex align-items-center">
                                    <div class="pr-3"><i class="icon ion-md-mail"></i></div>
                                    <span>{{ corporate.email }}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     </div>
</div>



